import {api} from './apiBase';

const url = '/Affiliation';

export function getAffiliationItensApi(accessToken, data) {
  api.headers.Authorization = `Bearer ${accessToken}`;

  return api.get(`${url}?affiliationType=${data}`);
}
